export const getInvoiceTemplates = (state) => state.invoiceTemplates
